const Elements = {
	applyLinks: 'apply-links',
};

export default Elements;
